"use client";

import { Fragment, type ReactNode } from "react";
import type { Section } from "./sections/section-types";

import { HeroSection } from "@/components/sections/hero";
import { HeaderSection } from "@/components/sections/header";
import { WeddingHeroPoster } from "@/components/wedding/weddingHero";
import { isWeddingPosterHero } from "@/lib/sections/hero.guards";

import { ScheduleSection } from "@/components/sections/schedule";
import { GallerySection } from "@/components/sections/gallery";
import { GiftsSection } from "@/components/sections/gifts";
import { FooterSection } from "@/components/sections/footer";
import { RsvpSection } from "@/components/sections/rsvp";

import { WeddingWelcomeSection } from "@/components/wedding/weddingWelcomeSection";
import { WeddingStorySection } from "@/components/wedding/weddingStory";
import { LocationSection } from "@/components/sections/location";
import { AccommodationsSection } from "@/components/accomodation/Accomodations";


export function SectionRenderer({ sections }: { sections: Section[] }) {
  return (
    <>
      {sections.map((section, index) => {
        let content: ReactNode = null;

        switch (section.type) {
          case "header":
            content = <HeaderSection {...section.props} />;
            break;

          case "hero": {
            const props = section.props;

            if (isWeddingPosterHero(props)) {
              content = (
                <WeddingHeroPoster
                  heroImage={props.heroImage}
                  coupleImage={props.coupleImage}
                  ringsImage={props.ringsImage}
                  label={props.label}
                  title={props.title}
                  date={props.date}
                  names={props.names}
                  tagline={props.tagline}
                />
              );
              break;
            }

            content = <HeroSection {...props} />;
            break;
          }

          case "welcome":
            content = <WeddingWelcomeSection {...section.props} />;
            break;

          case "weddingStory":
            content = <WeddingStorySection {...section.props} />;
            break;

          case "schedule":
            content = <ScheduleSection {...section.props} />;
            break;

          case "location":
            content = <LocationSection {...section.props} />;
            break;

          case "gallery":
            content = <GallerySection {...section.props} />;
            break;

          case "gifts":
            content = <GiftsSection {...section.props} />;
            break;

          case "accommodations":
            content = <AccommodationsSection {...section.props} />;
            break;

          case "footer":
            content = <FooterSection {...section.props} />;
            break;

          case "rsvp":
            content = <RsvpSection {...section.props} />;
            break;

          default:
            return null;
        }

        if (!content) return null;

        if (section.id) {
          return (
            <section key={index} id={section.id} data-section={section.type}>
              {content}
            </section>
          );
        }

        return <Fragment key={index}>{content}</Fragment>;
      })}
    </>
  );
}
